import { render, staticRenderFns } from "./screenMain.vue?vue&type=template&id=25399090&scoped=true"
import script from "./screenMain.vue?vue&type=script&lang=js"
export * from "./screenMain.vue?vue&type=script&lang=js"
import style0 from "./screenMain.vue?vue&type=style&index=0&id=25399090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25399090",
  null
  
)

export default component.exports